import { render, staticRenderFns } from "./ElogAuftragsNummer.vue?vue&type=template&id=6796a0f1&"
import script from "./ElogAuftragsNummer.vue?vue&type=script&lang=js&"
export * from "./ElogAuftragsNummer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
